export default {"src":"/_next/static/image/public/images/ic_plus.dd697870d96ade9a3a10a46e57252043.svg","height":14,"width":14};